import React from "react";

export default function Up() {
  return <i className="fas fa-chevron-up" />;
}
